import type { ManagementUpdateCup } from "../../../../core/models/cupsCifSelector/cupsCifSelector.model";
import type {
  ContactosRequestBody,
  ContactState,
  InputBlock,
} from "../../../../core/models/managementsUpdate/managementsUpdateContact/managementsUpdateContact.model";

const formatContactsListRequestBody = (
  inputsBlock: InputBlock[]
): ContactosRequestBody[] =>
  inputsBlock.map(({ contactName, cupGestion, contactValue }) => ({
    NombreContacto: contactName,
    TipoContacto: cupGestion,
    ValorContacto: contactValue,
  }));

const adaptCupsToContacts = (cups: ManagementUpdateCup[]): ContactState[] =>
  cups.map((cup) => ({
    cupsContractId: +cup.cupsContractId,
    supplyAddress: cup.supplyAddress,
    cupsCode: cup.cupsCode,
    envirorment: cup.envirorment,
    isDataLoaded: false,
    isUpdateContact: false,
    email: Array.from({ length: 5 }, (_, i) => ({
      name: `email${i + 1}`,
      value: "",
      error: null,
      required: i === 0,
    })),
    phone: Array.from({ length: 5 }, (_, i) => ({
      name: `phone${i + 1}`,
      value: "",
      error: null,
      required: i === 0,
    })),
  }));

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^(\+?\d{1,3}[-. ]?\d{3,6}[-. ]?\d{4,6})$|^(\d{7,15})$/;

// const PHONE_REGEX =
//   /^(?:(?:\+34|0034)?\s?)?(?:(6\d{8}|7\d{8}|9[0-8]\d{7}|8[0-9]\d{7}|800\d{6}|900\d{6}|90[1-9]\d{6}|80[3-7]\d{6}))$/;

export {
  formatContactsListRequestBody,
  adaptCupsToContacts,
  EMAIL_REGEX,
  PHONE_REGEX,
};
